import { render, staticRenderFns } from "./TagsColumn.vue?vue&type=template&id=17b99dd2&scoped=true&"
import script from "./TagsColumn.vue?vue&type=script&lang=js&"
export * from "./TagsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b99dd2",
  null
  
)

export default component.exports